import { useDispatch } from "react-redux";
import {
    setFloatingContainerState,
    setFloatingWindowState,
    setHeaderState,
    setSendMessageContainerState
} from "../../../features/componentStateSlice.js";
import minimize_icon from "/content/dam/hlb/my/chatbot/images/minus.png";
import { useSelector } from "react-redux";
import { formatDataMinimizeChat } from "../../../utils/formatData.js";
import { setMessages } from "../../../features/messagesSlice.js";

export default function MinimizeButton() {
    const dispatch = useDispatch();
    const rateMessageData = useSelector(state => state.messages.rateMessageData);
    const messages = useSelector(state => state.messages.messages);

    const handleMinimizeFloatingWindow = () => {
        const saveMessages = formatDataMinimizeChat(messages, rateMessageData)
        dispatch(setMessages(saveMessages))
        dispatch(setFloatingContainerState(true));
        dispatch(setFloatingWindowState(false));
        dispatch(setHeaderState(false));
        dispatch(setSendMessageContainerState(false));
    };

    return (
        <button id="minimize-chat" onClick={ handleMinimizeFloatingWindow }>
            <img src={ minimize_icon } alt="minimize" className="minimize-icon" />
        </button>
    );
};
